<template>
  <el-dialog :visible.sync="show" :title="name" width="600px">
    <el-form ref="form" size="small" :model="data" label-width="120px" label-position="right" :rules="rules">
      <el-form-item prop="name" label="标题">
        <el-input v-model="data.name" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item prop="second_name" label="副标题">
        <el-input v-model="data.second_name" placeholder="请输入副标题"></el-input>
      </el-form-item>
      <el-form-item prop="type" label="类型">
        <el-select v-model="data.type" placeholder="请选择类型" :disabled="isUpdate" style="width: 100%">
          <el-option v-for="(item, index) in typeOptions" :key="index" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="enable" label="是否上架" v-if="isUpdate">
        <el-select v-model="data.enable" placeholder="请选择是否上架" style="width: 100%">
          <el-option v-for="(item, index) in [{ value: true, label: '是' }, { value: false, label: '否' }]" :key="index"
            :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="banner_topic" label="是否banner" v-if="isUpdate">
        <el-select v-model="data.banner_topic" placeholder="请选择是否banner" style="width: 100%">
          <el-option v-for="(item, index) in [{ value: true, label: '是' }, { value: false, label: '否' }]" :key="index"
            :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <img-upload v-if="data.banner_topic" :data="data" field="banner_image_url" model="sys_shop_special_topic"
        :limit="1" :rules="rules" label="图片" />
    </el-form>
    <template slot="footer">
      <div style="text-align: center">
        <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import imgUpload from '@/imgUpload.vue';
export default {
  name: 'Detail',
  data() {
    return {
      data: {},
      rules: {
        name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        second_name: [{ required: true, message: '请输入副标题', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        enable: [{ required: true, message: '请选择是否上架', trigger: 'change' }],
        banner_topic: [{ required: true, message: '请选择是否banner', trigger: 'change' }],
        banner_image_url: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
      show: false,
      name: '',
      isUpdate: false,
      loading: false,
      typeOptions: [
        { value: 'LaboratoryReport', label: '化验报告' },
        { value: 'TenantProduct', label: '煤种报价' }
      ]
    }
  },
  components: { imgUpload },
  methods: {
    display(event) {
      this.data = event.data
      this.name = event.name
      this.isUpdate = event.isUpdate
      this.show = true
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          let url
          if (this.isUpdate) {
            url = this.$axios.post('/paas/eventEmit/emit/sys_shop_special_topic/sys_shop_special_topic_update', this.data)
          } else {
            url = this.$axios.post('/paas/eventEmit/emit/sys_shop_special_topic/sys_shop_special_topic_create', this.data)
          }
          url.then(() => {
            this.loading = false
            this.show = false
            this.$message.success({ showClose: true, message: this.isUpdate ? '保存成功' : '添加成功' })
            this.$emit('init')
          })
        }
      })
    }
  }
}
</script>